import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { HTTP } from "../../api/resources";
import InvoiceLineItem from "./InvoiceLineItem";
import Flatpickr from "react-flatpickr";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import Select from "react-select";
import PaymentDateModal from '../Helpers/Modal/PaymentDateModal'
import DonationModal from "../Helpers/Modal/DonationModal";
import ConfirmationModal from "../Helpers/Modal/ConfirmationModal";
import StripeAccounts from "./Modals/StripeAccounts";


export default function InvoicesEdit( { 
  invoices: invoicesProps, invoice: invoiceProps, 
  lineItems: lineItemsProps, donations: donationProps, 
  donor: donorProps, custom_fields: customFieldsProps, 
  team: teamProps, schedule: scheduleProps , 
  user: userProps, connections: connectionProps, 
  today: todayProps, archivedIds: archivedProps, 
  stripe_accounts: stripeAccountsProps
} ) {
  const [invoice, setInvoice] = useState(invoiceProps);
  const [schedule, setSchedule] = useState(scheduleProps);
  const [isRecurring, setIsRecurring] = useState(invoiceProps.isRecurring);
  const [lineItems, setLineItems] = useState(lineItemsProps);
  const [saving, setSaving] = useState(false);
  const [totalInvoiceAmount, setTotalInvoiceAmount] = useState(0);
  const [orgName, setOrgName] = useState(teamProps.name);
  const [logoUrl, setLogoUrl] = useState(teamProps.logo_url);
  const [childrenOld, setChildrenOld] = useState([]);
  const [isPaid, setIsPaid] = useState(invoice.payments.length > 0);
  const [datePicker, setDatePicker] = useState(false)
  const [openEndDateAlert, setOpenEndDateAlert] = useState(false)
  const [selectedDate, setSelectedDate] = useState("");
  const [openPaymentsModal, setOpenPaymentModal] = useState(false)
  const [savingPayments, setSavingPayments] = useState(false)
  const [openAutopay, setOpenAutopay] = useState(false)
  const [saveingDonation, setSavingDonation] = useState(false)
  const [openDonation, setOpenDonation] = useState(false)
  const [markable, setMarkable] = useState(false)
  const [donations, setDonations] = useState(donationProps)
  const [openSubscriptions, setOpenSubscription] = useState(false)
  const [openDateAlert, setOpenDateAlert] = useState(false)
  const [invoiceDate, setInvoiceDate] = useState(null)
  const [amountWithFee, setAmountWithFee] = useState(0)
  const [remainingBalance, setRemainingBalance] = useState(0)
  const [openAccountModal, setOpenAccountModal] = useState(false)
  const [stripeAccounts, setStripeAccounts] = useState([])
  const [selectedAccount, setSelectedAccount] = useState(null)
  let coreLineItems = [];
  let currentDate = new Date();
  const [invoiceStatus, setInvoiceStatus] = useState(
    invoiceProps.status === "active" ? true : false
  );
  const user = userProps
  const [passProcessingFee, setPassProcessingFee] = useState(invoice.pass_processing_fee)
  const [openFeeModal, setOpenFeeModal] = useState(false)
  const [hideOfferAutoPay, setHideOfferAutoPay] = useState(false)
  const notEditable = invoice.status == "active" || invoice.status == "overdue" || invoice.status == "sent" || invoice.status == "paid"
  const editable = !invoice.status || invoice.status === "draft"

  const recurrencePeriodOptions = [
    { value: "months", label: "Months" },
    { value: "weeks", label: "Weeks" },
    { value: "days", label: "Days" },
  ];
  const dueDatePeriodOptions = [
    { value: "next_month", label: "Next Month" },
    { value: "current_month", label: "Current Month" },
  ];

  const [paidAmount, setPaidAmount] = useState(invoice.paid_amount)

  const getCurrentDateInUserTimezone = () => {
    const currentDate = new Date();
    const timeZoneOffset = currentDate.getTimezoneOffset() * 60000;
    const userTime = new Date(currentDate.getTime() - timeZoneOffset);
    const userDate = userTime.toISOString().slice(0, 10);
    return userDate;
  };


  let todaysDate = getCurrentDateInUserTimezone()

  useEffect(() => {
    if (!invoice.isRecurring) {
      setInvoice({...invoice, is_endless_invoice: false})
    }

    if (invoice.isRecurring) {
      if (schedule.expiration_date) setInvoice({...invoice, is_endless_invoice: false})
      if (!schedule.expiration_date) setInvoice({...invoice, is_endless_invoice: true})
    }
  }, [schedule, invoice.isRecurring])

  useEffect(() => {
    if (lineItems) {
      let netAmount = 0;
      for (const lineItem in lineItems) {
        const donation_id = lineItems[lineItem].donation_id;
        for (const donation in donations) {
          if (donation_id == donations[donation].id) {
            const donation_amount = donations[donation].unit_cost;
            const donation_quantity = lineItems[lineItem].quantity;
            const donation_tax = lineItems[lineItem].tax;
            netAmount =
              netAmount +
              +donation_amount * +donation_quantity +
              parseFloat(donation_tax);
            let netAmountFixed = netAmount.toFixed(2);
            setTotalInvoiceAmount(netAmountFixed);
          }
        }
      }
    }
  }, [lineItems]);
  // validate dates
  const validateDates = () => {
    const yesterday = new Date(currentDate);
    const today = new Date(currentDate);
    yesterday.setDate(currentDate.getDate() - 1);
    today.setDate(currentDate.getDate());
    let dueDate = new Date(invoice.due_date);
    if (dueDate <= today && !isRecurring && dueDate) {
      Alert.show("notice", "Due date cannot be today or in the past");
      setInvoice({ ...invoice, due_date: null });
      return true;
    }
  };

  useEffect(() => {
    let currentInvoice = invoiceProps
    let donor_id = donorProps.id

    if (currentInvoice.invoice_number == null) {
      let lastInvoiceNumber = teamProps.last_invoice_number
      let newInvoiceNumber = parseInt(lastInvoiceNumber) + 1
      setInvoice({
        ...invoiceProps,
        invoice_number: String(newInvoiceNumber)
      })
    }

    if (invoice.invoice_date && new Date(invoice.invoice_date) <= new Date()) {
      setHideOfferAutoPay(true)
    }

    if (invoice.status == 'paid') {
      invoice.payments.map(payment => {
        if (payment.method.includes('Stripe')) {
          setMarkable(true)
          return
        }
      })
    }

    configureStripeAccounts()
  }, []);

  const configureStripeAccounts = () => {
    let allAccounts = [ {id: 1, real_id: null, name: `${teamProps.stripe_account_name} (main)`} ]
    if (stripeAccountsProps && stripeAccountsProps.length > 0) {
      stripeAccountsProps.map(account => {
        let holder = {id: allAccounts.length + 1, real_id: account.id, name: account.name}
        allAccounts.push(holder)
      })
    }

    if (!invoice.stripe_id && allAccounts && allAccounts.length > 0) {
      setSelectedAccount(allAccounts[0])
    }

    if (invoice.stripe_id && allAccounts && allAccounts.length > 0) {
      let holder = allAccounts.find(account => account.real_id == invoice.stripe_id)
      if (holder) setSelectedAccount(holder)
    }
    setStripeAccounts(allAccounts ? allAccounts : [])
  }

  const dataValidation = async () => {
    if (validateDates()) return;

    if (invoice.system_generated) {
      Alert.show('notice', 'You cannot update a system generated invoice')
      return
    }

    if (donorProps.archived) {
      Alert.show('notice', 'You cannot update an invoice belong to an archived user')
      return
    }

    if (invoice.use_stripe && totalInvoiceAmount <= 0.50){
      Alert.show('notice', 'Amount cannot be less than $0.50USD when using Stripe payments')
      return
    }

    if (invoice.status && invoice.status == 'paid') {
      Alert.show('notice', 'Invoice has already been paid and cannot be updated')
      return
    }

    if (!isRecurring) {
      if (!invoice.due_date || !invoice.invoice_date) {
        Alert.show("notice", "Please select an invoice date and due date");
        return;
      }
    } else if (isRecurring) {
      if (!invoice.invoice_date || (!schedule.expiration_date && !invoice.is_endless_invoice)) {
        Alert.show("notice", "Please select a start date and end date");
        return;
      }

      if (
        !schedule.recurrence_quantity ||
        !schedule.due_date_day ||
        !schedule.due_date_type ||
        !schedule.recurrence_period
      ) {
        Alert.show(
          "notice",
          "All fields are required to set up recurring invoice"
        );
        return;
      }

      if (schedule.recurrence_quantity < 1 || schedule.due_date_day < 1) {
        Alert.show("notice", "The schedule dates can not be 0 or negative");
        return;
      }

      let date = new Date(invoice.invoice_date)
      let options = { day: 'numeric' }
      let formattedDate = date.toLocaleDateString(undefined, options)

      if (schedule.due_date_type == 'current_month' && parseInt(formattedDate) >= parseInt(schedule.due_date_day) && invoice.use_stripe) {
        Alert.show('notice', 'The due date for the current month is in the past, select next month or change due date')
        return
      }

      if (invoice.auto_pay) {
        Alert.show('notice', 'This invoice has an active auto pay, you can only delete the invoice')
        return
      }

      let dateHolder = new Date(`${todaysDate}`)
      let currentMonth = dateHolder.getMonth() + 1

      if (schedule.due_date_type == 'current_month' && schedule.due_date_day > 30 && [4, 6, 9, 11].includes(currentMonth)) {
        Alert.show('notice', 'The current month does not have more than thirty days')
        return
      }

      if (schedule.due_date_type == 'current_month' && schedule.due_date_day > 28 && currentMonth == 2) {
        Alert.show('notice', 'The current month does not have more than twenty eight days')
        return
      }

      if (schedule.due_date_type == 'next_month' && schedule.due_date_day > 30 && [4, 6, 9, 11].includes(currentMonth + 1)) {
        Alert.show('notice', 'The next month does not have more than thirty days')
        return
      }

      if (schedule.due_date_type == 'next_month' && schedule.due_date_day > 28 && currentMonth + 1 == 2) {
        Alert.show('notice', 'The next month does not have more than twenty eight days')
        return
      }
    }

    let lastCheck = false;
    lineItems.map((item) => {
      if (
        item.quantity < 1 ||
        item.tax < 0 ||
        item.tax == null ||
        item.quantity == null
      ) {
        Alert.show(
          "notice",
          "Line items must have a valid quantity and tax amount"
        );
        lastCheck = true;
      }

      if (archivedProps.length > 0) {
        if (archivedProps.includes(item.donation_id)) {
          Alert.show('notice', 'You cannot update the invoice with an archived donation item')
          lastCheck = true
        }
      }
    });

    if (lastCheck) return;

    handleSubmit();
  };

  const handleSubmit = () => {
    setSaving(true);

    HTTP.patch(`/d/${invoice.user_id}/invoices/${invoiceProps.id}`, {
      invoice: invoice,
      line_items: lineItems,
      totalInvoiceAmount: totalInvoiceAmount,
      schedule: schedule,
      childrenOld: childrenOld,
      payment_date: invoice.payment_date,
    })
      .then((response) => {
        Alert.show("notice", "Invoice Saved!");
        setInvoice(response.data);
        setSaving(false);
        setTimeout(
          () => (window.location = `/d/${invoice.user_id}/invoices`),
          1500
        );
      })
      .catch((e) => {
        Alert.show("error", "Could not save. Try again or refresh.");
        setSaving(false);
      });
  };

  const handleDelete = (lineItem) => {
    removeLineItem(lineItem);
    if (!lineItem.id) {
      return;
    }
  };

  const removeLineItem = (lineItem) => {
    let array = [...lineItems]; // make a separate copy of the array
    _.remove(array, { _id: lineItem._id });
    setLineItems(array);
  };

  const updateLineItem = (lineItem, update) => {
    setLineItems(
      [...lineItems].map((object) => {
        if (object._id === lineItem._id) {
          return {
            ...object,
            ...update
          };
        } else return object;
      })
    );
  };

  const handleAddItemLine = () => {
    setLineItems([
      ...lineItems,
      {
        new: `new-${lineItems.length}`,
        quantity: 1,
        tax: 0,
        donation_id: null,
        beneficiary: {
          id: 0,
          name: "All Connections",
          type: "default"
        }
      },
    ]);
  };

  const handlePaymentLink = () => {
    donations.map(d => {
      if(d.stripe_price_id === null && d.stripe_product_id === null) {
        createStripeProduct(d, teamProps, secretKeyProps, publicKeyProps).then(data => {
          setDonations(data)
        })
      }
    })
  };

  if (lineItems.length == 0) {
    handleAddItemLine();
  }

  for (const [index, lineItem] of lineItems.entries()) {
    let _id = lineItem.id || lineItem.new;
    lineItem._id = _id;

    coreLineItems.push(
      <InvoiceLineItem
        key={_id}
        lineItem={lineItem}
        updateLineItem={updateLineItem}
        handleDelete={handleDelete}
        donations={donations}
        invoice={invoice}
        connections = {connectionProps}
      />
    );
  }

  const handleInvoiceStatusToggleSwitch = () => {
    if (invoiceStatus) {
      setInvoice((invoice) => ({ ...invoice, status: "draft" }));
    } else if (!invoiceStatus) {
      setInvoice((invoice) => ({ ...invoice, status: "active" }));
    }
  };

  const destroyChildren = (invoice) => {
    setChildrenOld(invoice.child_invoices);
    if (invoice.child_invoices > 0) {
      setInvoice((invoice) => ({ ...invoice, child_invoices: [] }));
    }
  };

  const checkPaymentStatus = (value) => {
    if (!value) {
      if (window.confirm('This will remove payment date and payment type record from invoice')) {
        deleteInvoicePayment()
      }
      return
    } else {
      setOpenPaymentModal(true)
      return
    }
  }

  const deleteInvoicePayment = async () => {
    let data = {
      request_type: 'delete'
    }

    let response = null
    try {
      response = await updatePaymentInfo(data)
    } catch {
      Alert.show('error', 'Could not update, try again')
      return
    }

    Alert.show('notice', 'Deleted payment date and type record')
    setInvoice(response.data)
    setOpenPaymentModal(false)
    setSavingPayments(false)
    setIsPaid(false)
  }

  useEffect(() => {
    if (invoice.status == 'active') {
      setInvoiceStatus(true)
    }
  }, [isPaid])

  const handleAddDate = async (date, selectedPaymentType, amount) => {
    if (!date || date.length < 1) {
      Alert.show('notice', 'Payment date is required to save record')
      return
    }

    if (!selectedPaymentType) {
      Alert.show('notice', 'Payment method is required to save record')
      return
    }

    if (!amount || amount < 1) {
      Alert.show('notice', 'Payment amount is required to save record')
      return
    }

    setSavingPayments(true)

    let data = {
      request_type: 'update',
      payment_info: {
        payment_type: selectedPaymentType.method,
        payment_date: date,
        payment_amount: amount
      }
    }

    let response = null

    try {
      response = await updatePaymentInfo(data)
    } catch {
      Alert.show('error', 'Could not save record, try again')
      setIsPaid(false)
      setSavingPayments(false)
      return
    }

    Alert.show('notice', 'Saved record successfully')
    setIsPaid(true)
    setSavingPayments(false)
    setInvoice(response.data)
    setOpenPaymentModal(false)
  }

  const updatePaymentInfo = (data) => {
    return HTTP.patch(`/invoice/paymentinfo/${invoice.id}/${invoice.user_id}`, data)
  }

  const processFeeChange = (e) => {
    if (!invoice.pass_processing_fee) {
      setOpenFeeModal(true)
      return
    }

    setInvoice({...invoice, pass_processing_fee: false})
  }

  const processAutopay = (value) => {
    if (!invoice.offer_auto_pay) {
      setOpenAutopay(true)
      return
    }

    setInvoice({...invoice, offer_auto_pay: false})
  }
  // One time donation item creation
  const handleCreateDonation = async (donation, save) => {
    if (!donation.name || !donation.description || !donation.unit_cost || !donation.currency) {
      Alert.show('notice', 'All input fields are required')
      return
    }

    setSavingDonation(true)

    if (!save) donation.attached_invoice_id = invoice.id

    try{
      let response = await newDonationItem(donation)
      addDonationToLineItems(response.data)
    } catch {
      Alert.show('error', 'Could not create item, try again')
      setSavingDonation(false)
      return
    }
  }

  const newDonationItem = (data) => {
    return HTTP.post('/donations/create/onetime', data)
  }

  // Adds the newly created donation item as a selected item on a new row
  const addDonationToLineItems = (donation) => {
    setDonations([...donations, donation])
    setLineItems([
      ...lineItems,
      {
        new: `new-${lineItems.length}`,
        quantity: 1,
        tax: 0,
        donation_id: donation.id,
        beneficiary: {
          id: 0,
          name: "All Connections",
          type: "default"
        }
      },
    ]);

    setSavingDonation(false)
    setOpenDonation(false)
    Alert.show('notice', 'Donation item created successfully')
  }

  const handleNotificationChange = (val) => {
    if (invoice.send_notification) setInvoice({...invoice, send_notification: false})
    if (!invoice.send_notification) setInvoice({...invoice, send_notification: true})
  }

  const handleInvoiceDate = (dateStr, date) => {
    let selectedDate = new Date(dateStr)

    if (invoice.isRecurring && selectedDate <= new Date(todaysDate)) {
      setOpenDateAlert(true)
    }

    setInvoice({...invoice, invoice_date: dateStr})
    setHideOfferAutoPay(false)
  }

  useEffect(() => {
    if (hideOfferAutoPay){
      setInvoice({...invoice, offer_auto_pay: false})
    }
  }, [hideOfferAutoPay])

  const handleEndDate = (dateStr, date) => {
    if (invoice.isRecurring && !invoice.invoice_date) {
      setOpenEndDateAlert(true)
      return
    }

    let date1 = new Date(invoice.invoice_date);
    let date2 = new Date(dateStr);

    if (invoice.isRecurring && date1 >= date2) {
      setOpenEndDateAlert(true)
      return
    }

    setSchedule((schedule) => {
      return { ...schedule, expiration_date: dateStr };
    });

    if (invoice.isRecurring) {
      if (!dateStr) setInvoice({...invoice, is_endless_invoice: true})
      if (dateStr) setInvoice({...invoice, is_endless_invoice: false})
    }
  }

  useEffect(() => {
    if (openEndDateAlert == true) {
      setSchedule({...schedule, expiration_date: null})
    }
  }, [openEndDateAlert == true])

  useEffect(() => {
    if (invoice.isRecurring) {
      let amount = totalInvoiceAmount * 0.034 + 0.30
      setAmountWithFee(totalInvoiceAmount + amount)
      setRemainingBalance(amountWithFee - invoice.paid_amount)
      if (invoice.status == 'paid') setRemainingBalance(0.00)
    }

    if (!invoice.isRecurring) {
      let amount = totalInvoiceAmount * 0.029 + 0.30
      setAmountWithFee(totalInvoiceAmount + amount)
      setRemainingBalance(amountWithFee - invoice.paid_amount)
      if (invoice.status == 'paid') setRemainingBalance(0.00)
    }
  }, [invoice])

  const handleAccountAddition = (account) => {
    setInvoice({...invoice, stripe_id: account.real_id})
    setSelectedAccount(account)
    setOpenAccountModal(false)
  }

  const getInvoiceAmount = (amount) => {
    let total = amount

    if (invoice.use_stripe && invoice.pass_processing_fee) {
      if (invoice.isRecurring) {
        total = parseFloat(amount) * 0.034 + 0.30
        total = parseFloat(amount) + parseFloat(total)
      }

      if (!invoice.isRecurring) {
        total = parseFloat(amount) * 0.029 + 0.30
        total = parseFloat(total) + parseFloat(amount)
      }
    }

    return parseFloat(total).toFixed(2)
  }

  const handleContinuousInvoice = (checked) => {
    if (checked) {
      setInvoice({...invoice, is_endless_invoice: true, end_date: null})
      setSchedule({ ...schedule, expiration_date: null })
    } else {
      setInvoice({...invoice, is_endless_invoice: false})
    }
  }


  return (
    <React.Fragment>
      <div className="page-header d-flex align-items-baseline">
        <h4>
          <a href={`/d/${invoice.user_id}/invoices`}>
            <i className="fa fa-chevron-left mr-2"></i> Back
          </a>
        </h4>
        <ul className="breadcrumbs">
          <li className="nav-item">Invoices</li>
          <li className="separator">
            <i className="fa fa-arrow-right"></i>
          </li>
          <li className="nav-item">{invoice.invoice_number}</li>
        </ul>

        {invoice.use_stripe && teamProps.stripe_uid &&
          <div className="page-actions">
            <button className="btn btn-primary" onClick={() => setOpenAccountModal(true)}>
              Select Stripe Account
            </button>
          </div>
        }
      </div>
      <div className="card">
        <div className="card-header flex-header">
          <h4 className="card-title">Invoice Editor</h4>
          <div>
            {invoice.auto_pay && !invoice.system_generated &&
              <span className="text-danger mr-3">
                <b>This invoice has auto pay currently active and can't be updated</b>
              </span>
            }

            {invoice.status && invoice.status == 'paid' && !invoice.system_generated &&
              <span className="text-danger mr-3">
                <b>This invoice has been paid and can't be updated</b>
              </span>
            }
            {invoice.system_generated &&
              <span className="text-danger mr-3">
                <b>This invoice is system generated and cannot be edited</b>
              </span>
            }
            {donorProps.archived &&
              <span className="text-danger mr-3">
                <b>This user has been archived hence the invoice cannot be edited</b>
              </span>
            }
            <button
              onClick={dataValidation}
              name="button"
              className="btn btn-primary"
            >
              {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
              Save
            </button>
          </div>
        </div>
        <div className="card-body">
          <div className="row f-row-in">
            <div className="col-md-5">
              <div className="in-logo-container">
                {logoUrl && (
                  <img src={logoUrl} alt={orgName} className="logo-invoice" />
                )}
                {!logoUrl && (
                  <img
                    src="http://giveclarity.co/logo.png"
                    alt="Clarity"
                    className="logo-invoice"
                  />
                )}
              </div>
              <h4>{orgName}</h4>
            </div>
            <div className="col-md-4">
              <h1 className="invoice-he-ti">INVOICE</h1>
            </div>
            <div
              className="col-md-3 invoice-status"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <strong>Status</strong>
                {invoice.status != "overdue" &&
                  invoice.status != "sent" &&
                  invoice.status != "paid" &&
                  !invoice.auto_pay &&
                  (user.user_type == 'manager' || user.user_type == 'assistant_manager') &&(
                    <span className="capybara-active-toggle">
                      <ToggleSwitch
                        small
                        id="invoice_is_active"
                        checked={invoiceStatus}
                        onChange={(checked) => {
                          setInvoiceStatus(checked);
                          handleInvoiceStatusToggleSwitch();
                          if (!checked) {
                            destroyChildren(invoice);
                          }
                        }}
                      />
                    </span>
                  )}
                <div>
                  {invoice.status
                    ? invoice.status.charAt(0).toUpperCase() +
                      invoice.status.slice(1)
                    : "Draft"}
                </div>
              </div>
              <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                <strong>Invoice reminders</strong>
                {invoice.status != "overdue" && invoice.status != "sent" && invoice.status != "paid" &&
                  invoice.status != "active" &&
                  (user.user_type == 'manager' || user.user_type == 'assistant_manager') &&(
                    <span>
                      <ToggleSwitch
                        small
                        id="send_notification"
                        checked={invoice.send_notification}
                        onChange={(checked) => {
                          handleNotificationChange(checked)
                        }}
                      />
                    </span>
                  )}
                  <div>
                    {invoice.send_notification && <>Active</>}
                    {!invoice.send_notification && <>No</>}
                  </div>
              </div>
              {teamProps.stripe_uid &&
              <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                <strong>Stripe for payments</strong>
                {invoice.status != "overdue" && invoice.status != "sent" && invoice.status != "paid" &&
                  invoice.status != "active" &&
                  (user.user_type == 'manager' || user.user_type == 'assistant_manager') &&(
                    <span>
                      <ToggleSwitch
                        small
                        id="stripe_payments"
                        checked={invoice.use_stripe}
                        onChange={(checked) => {
                          if (checked) {
                            setInvoice({...invoice, use_stripe: checked})
                          } else {
                            setInvoice({...invoice, use_stripe: checked, offer_auto_pay: false, pass_processing_fee: false})
                          }
                        }}
                      />
                    </span>
                  )}
                  <div>
                    {invoice.use_stripe && <>Yes</>}
                    {!invoice.use_stripe && <>No</>}
                  </div>
              </div>
              }

              {(invoice.status == "active" || invoice.status == "paid" || invoice.status == 'sent') && invoice.isRecurring == false && invoiceProps.invoice_date && !markable &&
              (user.user_type == 'manager' || user.user_type == 'assistant_manager') && (
                <div className="mt-1" style={{ display: "flex", alignItems: "center", width: "100%" }}>
                  <label htmlFor="payment me-2"><strong>Mark As Paid</strong></label>
                  <input type="checkbox" checked={isPaid} onChange={(e) => checkPaymentStatus(e.target.checked)} id="payment"/>
                </div>
              )}

              {invoice.payments.length > 0 && invoice.isRecurring == false && (
                <div className="mt-1" style={{ display: "flex", alignItems: "center", width: "100%" }}>
                  <label htmlFor="payment me-2"><strong>Number Of Payments:</strong> {invoice.payments.length}</label>
                </div>
              )}

              {invoice.payments.length > 0 && invoice.paid_amount > 0 && invoice.isRecurring == false && (
                <div className="mt-1" style={{ display: "flex", alignItems: "center", width: "100%" }}>
                  <label htmlFor="payment me-2"><strong>Total Paid Amount:</strong> ${invoice.paid_amount}</label>
                </div>
              )}

              {invoice.payments.length > 0 && invoice.paid_amount < totalInvoiceAmount && invoice.paid_amount > 0 && invoice.isRecurring == false && !markable && (
                <div className="mt-2" style={{ display: "flex", alignItems: "center", width: "100%" }}>
                  <button
                    onClick={() => setOpenPaymentModal(true)}
                    name="button"
                    className="btn btn-sm btn-primary mr-2"
                  >
                    + Add Payment
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="row s-row-in">
            <div className="col-md-5">
              <div className="invoice-to">Invoice To: </div>
              <div>
                Donor: {donorProps.last_name}, {donorProps.first_name}
              </div>

              <div>{customFieldsProps.address}</div>
              <div>{customFieldsProps.city}</div>
              <div>{customFieldsProps.state}</div>
              <div>{customFieldsProps.code}</div>
              <div>{customFieldsProps.country}</div>
            </div>
            {(invoice.status == "active" ||
              invoice.status == "overdue" ||
              invoice.status == "sent" ||
              invoice.status == "paid") && (
              <div className="col-md-7 ">
                <div className="form-group rd-pad-in">
                  <label htmlFor="invoice_number">Invoice Number</label>
                  <input
                    className="form-control"
                    placeholder="00000001"
                    type="number"
                    name="invoice_number"
                    id="invoice_number"
                    value={invoice.invoice_number}
                    onChange={(e) => {
                      const val = e.target.value;
                      setInvoice((invoice) => {
                        return { ...invoice, invoice_number: val };
                      });
                    }}
                    disabled
                  />
                </div>
                {!isRecurring && !invoice.isRecurring &&
                  <div className="form-group rd-pad-in">
                    <label htmlFor="invoice_date">{isRecurring ? "Start Date" : "Invoice Date"}</label>
                    <Flatpickr className="form-control"
                      value={invoice.invoice_date}
                      onChange={(date, dateStr) => {
                        handleInvoiceDate(dateStr, date)
                      }}
                      disabled
                    />
                    {invoice.isRecurring &&
                      <small className='text-muted'>We recommend putting a gap of 5 days or more between today and your start date</small>
                    }
                  </div>
                }
                {!isRecurring && !invoice.isRecurring && (
                  <div className="form-group rd-pad-in">
                    <label htmlFor="due_date">Due Date</label>
                    <Flatpickr className="form-control"
                      value={invoice.due_date}
                      onChange={(date, dateStr) => {
                        setInvoice((invoice) => {
                          return { ...invoice, due_date: dateStr };
                        });
                      }}
                      disabled
                    />
                  </div>
                )}
              </div>
            )}
            {(!invoice.status || invoice.status === "draft") && (
              <div className="col-md-7 ">
                <div className="form-group rd-pad-in">
                  <label htmlFor="invoice_number">Invoice Number</label>
                  <input
                    className="form-control"
                    placeholder="00000001"
                    type="number"
                    name="invoice_number"
                    id="invoice_number"
                    value={invoice.invoice_number}
                    onChange={(e) => {
                      const val = e.target.value;
                      setInvoice((invoice) => {
                        return { ...invoice, invoice_number: val };
                      });
                    }}
                    disabled
                  />
                </div>
                {!isRecurring && !invoice.isRecurring &&
                  <div className="form-group rd-pad-in">
                    <label htmlFor="invoice_date">{isRecurring ? "Start Date" : "Invoice Date"}</label>
                    <Flatpickr className="form-control capybara-testing-start-date"
                      value={invoice.invoice_date}
                      onChange={(date, dateStr) => {
                        handleInvoiceDate(dateStr, date)
                      }}
                      options={{
                        disableMobile: true
                      }}
                    />
                    {invoice.isRecurring &&
                      <small className='text-muted'>We recommend putting a gap of 5 days or more between today and your start date</small>
                    }
                  </div>
                }
                {!isRecurring && !invoice.isRecurring && (
                  <div className="form-group rd-pad-in">
                    <label htmlFor="due_date">Due Date</label>
                    <Flatpickr className="form-control capybara-testing-due-date"
                      value={invoice.due_date}
                      onChange={(date, dateStr) => {
                        setInvoice((invoice) => {
                          return { ...invoice, due_date: dateStr };
                        });
                      }}
                      options={{
                        disableMobile: true
                      }}
                    />
                  </div>
                )}
              </div>
            )}
          </div>

          {coreLineItems}

          {(invoice.status == "active" ||
            invoice.status == "overdue" ||
            invoice.status == "sent" ||
            invoice.status == "paid") && (
            <div className="button-add-line-item">
              <button
                onClick={handleAddItemLine}
                disabled
                name="button"
                className="btn btn-sm btn-primary mr-2"
              >
                + Add Existing Donation Item
              </button>

              <button
                disabled
                name="button"
                className="btn btn-sm btn-primary mr-2"
              >
                + Create A New Donation Item
              </button>
            </div>
          )}
          {(!invoice.status || invoice.status === "draft") && (
            <div className="button-add-line-item">
              <button
                onClick={handleAddItemLine}
                name="button"
                className="btn btn-sm btn-primary mr-2"
              >
                + Add Existing Donation Item
              </button>

              <button
                onClick={() => setOpenDonation(true)}
                name="button"
                className="btn btn-sm btn-primary mr-2"
              >
                + Create A New Donation Item
              </button>
            </div>
          )}

          {invoice.status !== 'paid' && invoice.status !== 'sent' &&
            invoice.status !== 'active' && invoice.use_stripe &&
            <div className="row">
              <div className="col-md-6"></div>
              <div className="col-md-6">
                <div className="mt-3 custom-positoning-inv" style={{ display: "flex", alignItems: "center", width: "100%" }}>
                  <input type="checkbox" checked={invoice.pass_processing_fee} onChange={(e) => processFeeChange(e)} id="payment"/>
                  <label htmlFor="payment" style={{marginLeft: "5px"}}>
                    <b style={{color: "#2A2F5B"}}>Add payment processing fee to invoice</b>
                  </label>
                </div>
              </div>
            </div>
          }

          {(invoice.status == 'paid' || invoice.status == 'sent' ||
            invoice.status == 'active') && invoice.use_stripe &&
            <div className="row">
              <div className="col-md-6"></div>
              <div className="col-md-6">
                <div className="mt-3 custom-positoning-inv" style={{ display: "flex", alignItems: "center", width: "100%" }}>
                  <input type="checkbox"
                    checked={invoice.pass_processing_fee}
                    disabled
                    id="payment"
                  />
                  <label htmlFor="payment" style={{marginLeft: "5px"}}>
                    <b style={{color: "#2A2F5B"}}>Add payment processing fee to invoice</b>
                  </label>
                </div>
              </div>
            </div>
          }

          <div className="row">
            <div className="col-md-9"></div>
            <div className="col-md-3">
              <div className="form-group">
                <div style={{ textAlign: "center" }}>
                  <strong>Total Invoice Amount</strong>
                </div>
                <div style={{ textAlign: "center" }}>
                  {(!invoice.use_stripe || !invoice.pass_processing_fee) &&
                    <strong>${parseFloat(totalInvoiceAmount).toFixed(2)} USD</strong>
                  }

                  {invoice.use_stripe && invoice.pass_processing_fee &&
                    <strong>${getInvoiceAmount(totalInvoiceAmount)} USD</strong>
                  }
                </div>
              </div>
            </div>
          </div>

          {invoice.paid_amount > 0 && !invoice.isRecurring &&
            <div className="row">
            <div className="col-md-9"></div>
            <div className="col-md-3">
              <div className="form-group">
                <div style={{ textAlign: "center" }}>
                  <strong>Remaining Balance</strong>
                </div>
                <div style={{ textAlign: "center" }}>
                  {(!invoice.use_stripe || !invoice.pass_processing_fee) && invoice.status !== 'paid' &&
                    <strong>${(totalInvoiceAmount - invoice.paid_amount).toFixed(2)} USD</strong>
                  }

                  {(!invoice.use_stripe || !invoice.pass_processing_fee) && invoice.status == 'paid' &&
                    <strong>$0.00 USD</strong>
                  }

                  {invoice.use_stripe && invoice.pass_processing_fee &&
                    <strong>${remainingBalance.toFixed(2)} USD</strong>
                  }
                </div>
              </div>
            </div>
          </div>
          }

          {(invoice.status == "active" ||
            invoice.status == "overdue" ||
            invoice.status == "sent" ||
            invoice.status == "paid") && (
            <div>
              <div className="row">
                <div className="col-md-5"></div>
                <div className="col-md-7">
                  <div className="form-group">
                    <div>
                      <strong>Notes</strong>
                    </div>
                    <textarea
                      className="form-control"
                      placeholder="Add notes to the invoice here."
                      name="notes"
                      id="notes"
                      rows="4"
                      cols="50"
                      value={invoice.notes}
                      onChange={(e) => {
                        const val = e.target.value;
                        setInvoice((invoice) => {
                          return { ...invoice, notes: val };
                        });
                      }}
                      disabled
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-5"></div>
                <div className="col-md-7">
                  <div className="form-group">
                    <div>
                      <strong>Terms</strong>
                    </div>
                    <textarea
                      className="form-control"
                      placeholder="Add terms and conditions to the invoice here."
                      name="terms"
                      id="terms"
                      rows="4"
                      cols="50"
                      value={invoice.terms}
                      onChange={(e) => {
                        const val = e.target.value;
                        setInvoice((invoice) => {
                          return { ...invoice, terms: val };
                        });
                      }}
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          {(!invoice.status || invoice.status === "draft") && (
            <div>
              <div className="row">
                <div className="col-md-5"></div>
                <div className="col-md-7">
                  <div className="form-group">
                    <div>
                      <strong>Notes</strong>
                    </div>
                    <textarea
                      className="form-control"
                      placeholder="Add notes to the invoice here."
                      name="notes"
                      id="notes"
                      rows="4"
                      cols="50"
                      value={invoice.notes}
                      onChange={(e) => {
                        const val = e.target.value;
                        setInvoice((invoice) => {
                          return { ...invoice, notes: val };
                        });
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-5"></div>
                <div className="col-md-7">
                  <div className="form-group">
                    <div>
                      <strong>Terms</strong>
                    </div>
                    <textarea
                      className="form-control"
                      placeholder="Add terms and conditions to the invoice here."
                      name="terms"
                      id="terms"
                      rows="4"
                      cols="50"
                      value={invoice.terms}
                      onChange={(e) => {
                        const val = e.target.value;
                        setInvoice((invoice) => {
                          return { ...invoice, terms: val };
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {!isRecurring &&
        !invoice.isRecurring &&
        (!invoice.status || invoice.status === "draft") && (
          <div class="card card--accordion">
            <div class="card-header d-flex align-items-center justify-content-between">
              Is this a recurring invoice?
              <span className="capybara-recurring-selection">
                <ToggleSwitch
                  small
                  id="is_recurring"
                  checked={invoice.isRecurring}
                  onChange={(checked) => {
                    setInvoice((invoice) => ({
                      ...invoice,
                      isRecurring: checked,
                      due_date: null,
                      invoice_date: null
                    }));
                    setIsRecurring(checked);
                  }}
                />
              </span>
            </div>
          </div>
        )}

      {invoice.isRecurring && (
        <div class="card card--accordion">
          <div>
            <div class="card-header d-flex align-items-center justify-content-between">
              Is this a recurring invoice?
              {notEditable && 
                <ToggleSwitch
                  small
                  id="is_recurring"
                  checked={invoice.isRecurring}
                  onChange={(checked) => {
                    setInvoice((invoice) => ({
                      ...invoice,
                      isRecurring: checked,
                    }));
                    setIsRecurring(checked);
                  }}
                  disabled
                />
              }

              {editable && 
                <span className="capybara-recurring-selection">
                  <ToggleSwitch
                    small
                    id="is_recurring"
                    checked={invoice.isRecurring}
                    onChange={(checked) => {
                      setInvoice((invoice) => ({
                        ...invoice,
                        isRecurring: checked,
                      }));
                      setIsRecurring(checked);
                    }}
                  />
                </span>
              }
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 status-group">
              <div>
                <strong>
                  Please set the recurrence schedule for this invoice.
                </strong>
              </div>
            </div>
            {invoice.isRecurring && invoice.use_stripe && !hideOfferAutoPay &&
              <div className="col-md-6 status-group">
                <div className="mt-1" style={{ display: "flex", alignItems: "center", width: "100%" }}>
                    <input type="checkbox" checked={invoice.offer_auto_pay} onChange={(e) => processAutopay(e.target.checked)} id="autopay" disabled={notEditable}/>
                    <label htmlFor="autopay" style={{marginLeft: "5px"}}><b style={{color: "#2A2F5B"}}>Offer auto payments</b></label>
                </div>
              </div>
            }
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="recur-toggle-status">
                <div className="recur-status">
                  <strong>Recurring Invoice Settings:</strong>
                </div>
                <div className="recur-status-child">
                  Once recurring invoice is created and the invoice is
                  "Active", settings will not be able to change unless the
                  status is changed back to "Draft".
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group rd-pad-in">
                <label htmlFor="due_date_day">Due on the...</label>
                <input
                  className="form-control dim-input"
                  placeholder="1"
                  type="number"
                  name="due_date_day"
                  id="due_date_day"
                  value={schedule.due_date_day}
                  onChange={(e) => {
                    const val = e.target.value;
                    setSchedule((schedule) => {
                      return { ...schedule, due_date_day: val };
                    });
                  }}
                  disabled={notEditable}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group rd-pad-in">
                <label htmlFor="recurrence_quantity">
                  Repeat this transaction every...
                </label>
                <input
                  className="form-control dim-input"
                  placeholder="1"
                  min="1"
                  type="number"
                  name="recurrence_quantity"
                  id="recurrence_quantity"
                  value={schedule.recurrence_quantity}
                  onChange={(e) => {
                    const val = e.target.value;
                    setSchedule((schedule) => {
                      return { ...schedule, recurrence_quantity: val };
                    });
                  }}
                  disabled={notEditable}
                />
              </div>
            </div>
            <div className="col-md-6">
              {notEditable &&
                <div className="form-group" style={{paddingTop: '0px'}}>
                  <label>Day of the...</label>
                  <Select
                    className="form-control"
                    classNamePrefix="select-donation"
                    options={dueDatePeriodOptions}
                    value={dueDatePeriodOptions.find(
                      (option) => option.value === schedule.due_date_type
                    )}
                    onChange={(value) => {
                      setSchedule({
                        ...schedule,
                        due_date_type: value.value,
                      });
                    }}
                    isDisabled
                  />
                </div>
              }
              {editable && 
                <div className="form-group" style={{paddingTop: '0px'}}>
                  <label>Day of the...</label>
                  <Select
                    className="form-control"
                    classNamePrefix="select-donation"
                    options={dueDatePeriodOptions}
                    value={dueDatePeriodOptions.find(
                      (option) => option.value === schedule.due_date_type
                    )}
                    onChange={(value) => {
                      setSchedule({
                        ...schedule,
                        due_date_type: value.value,
                      });
                    }}
                  />
                </div>
              }
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              {editable && 
                <div className="form-group" style={{paddingTop: '0px'}}>
                  <label>Recurrence Period</label>
                  <Select
                    className="form-control"
                    classNamePrefix="select-donation"
                    options={recurrencePeriodOptions}
                    value={recurrencePeriodOptions.find(
                      (option) => option.value === schedule.recurrence_period
                    )}
                    onChange={(value) => {
                      setSchedule({
                        ...schedule,
                        recurrence_period: value.value,
                      });
                    }}
                  />
                </div>
              }

              {notEditable && 
                <div className="form-group" style={{paddingTop: '0px'}}>
                  <label>Recurrence Period</label>
                  <Select
                    className="form-control"
                    classNamePrefix="select-donation"
                    options={recurrencePeriodOptions}
                    value={recurrencePeriodOptions.find(
                      (option) => option.value === schedule.recurrence_period
                    )}
                    onChange={(value) => {
                      setSchedule({
                        ...schedule,
                        recurrence_period: value.value,
                      });
                    }}
                    isDisabled
                  />
                </div>
              }
            </div>
            <div className="col-md-6">
              {notEditable && 
                <div className="form-group rd-pad-in">
                  <label htmlFor="invoice_date">{isRecurring ? "Start Date" : "Invoice Date"}</label>
                  <Flatpickr className="form-control"
                    value={invoice.invoice_date}
                    onChange={(date, dateStr) => {
                      handleInvoiceDate(dateStr, date)
                    }}
                    disabled
                  />
                  {invoice.isRecurring &&
                    <small className='text-muted'>We recommend putting a gap of 5 days or more between today and your start date</small>
                  }
                </div>
              }
              {editable &&
                <div className="form-group rd-pad-in">
                  <label htmlFor="invoice_date">{isRecurring ? "Start Date" : "Invoice Date"}</label>
                  <Flatpickr className="form-control capybara-testing-start-date"
                    value={invoice.invoice_date}
                    onChange={(date, dateStr) => {
                      handleInvoiceDate(dateStr, date)
                    }}
                    options={{
                      disableMobile: true
                    }}
                  />
                  {invoice.isRecurring &&
                    <small className='text-muted'>We recommend putting a gap of 5 days or more between today and your start date</small>
                  }
                </div>
              }
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              {editable && 
                <div className="form-group rd-pad-in">
                  <label htmlFor="expiration_date">When should recurring invoice end?</label>
                  <Flatpickr className="form-control capybara-testing-end-date"
                    value={schedule.expiration_date}
                    onChange={(date, dateStr) => {
                      handleEndDate(dateStr, date)
                    }}
                    options={{
                      disableMobile: true
                    }}
                  />
                  <small className='text-muted'>Leave empty to use endless invoice</small>
                </div>
              }
              {notEditable && 
                <div className="form-group rd-pad-in">
                  <label htmlFor="expiration_date">When should recurring invoice end?</label>
                  <Flatpickr className="form-control"
                    value={schedule.expiration_date}
                    onChange={(date, dateStr) => {
                      handleEndDate(dateStr, date)
                    }}
                    disabled
                  />
                  <small className='text-muted'>Leave empty to use endless invoice</small>
                </div>
              }
            </div>
            <div className="col-md-6"></div>
          </div>
        </div>
      )}

      {/* modals */}
      {openPaymentsModal &&
        <PaymentDateModal handleClose={() => setOpenPaymentModal(false)} saving={savingPayments}
          handleAddDate={(date, selectedPaymentType, amount) => handleAddDate(date, selectedPaymentType, amount)}
          balance={totalInvoiceAmount - invoice.paid_amount}
        />
      }

      {openDonation &&
        <DonationModal
          handleAddItem={(donation, save) => handleCreateDonation(donation, save)}
          handleClose={() => setOpenDonation(false)}
          saving={saveingDonation}
        />
      }

      {openFeeModal &&
        <ConfirmationModal cancel={() => setOpenFeeModal(false)} proceed={() => {
          setInvoice({...invoice, pass_processing_fee: true})
          setOpenFeeModal(false)
        }}
        message="Please ensure that passing payment processing fees to your donors complies with the laws and regulations in your jurisdiction"
        />
      }

      {openAutopay &&
        <ConfirmationModal cancel={() => setOpenAutopay(false)} proceed={() => {
          setInvoice({...invoice, offer_auto_pay: true})
          setOpenAutopay(false)
        }}
        message="Our payment system will give the user an option to pay each invoice in this recurring invoice individually or sign up for autopay"
      />
      }
        {openDonation &&
        <DonationModal
          handleAddItem={(donation, save) => handleCreateDonation(donation, save)}
          handleClose={() => setOpenDonation(false)}
          saving={saveingDonation}
        />
      }

      {openDateAlert &&
        <ConfirmationModal
          message="Recurring invoice start date must be in the future."
          cancel={() => {
            setHideOfferAutoPay(true)
            setOpenDateAlert(false)
            setInvoice({...invoice, invoice_date: null})
          }}
          cancelButton='Update Start Date'
        />
      }

      {openEndDateAlert &&
        <ConfirmationModal
          message="Recurring invoice end date must be greater than start date."
          cancel={() => {
            setSchedule({...schedule, expiration_date: ''})
            setOpenEndDateAlert(false)
          }}
          cancelButton='Update End Date'
        />
      }

      {openAccountModal &&
        <StripeAccounts 
          accounts={stripeAccounts} team={teamProps} 
          close={() => setOpenAccountModal(false)}
          proceed={(account) => handleAccountAddition(account)}
          invoice={invoice}
          account={selectedAccount}
        />
      }
    </React.Fragment>
  );
}

InvoicesEdit.propTypes = {
  invoice: PropTypes.object,
  schedule: PropTypes.object,
};
